<div class="our-partner-header d-flex">
  <h2 class="mb-0">{{ "partner-depts.head" | translate }}</h2>
  <span (click)="partnerDialogRef.close()" class="cursor-pointer"
    ><img 
    src="https://media.umangapp.in/cdn/landing/close.svg" 
    alt=""
    loading="lazy"
    fetchpriority="high"
    
  /></span>
</div>
<mat-dialog-content class="our-partner-container">
  <p>
    {{ "partner-depts.dialog.pt-1" | translate }}
  </p>
  <p>
    {{ "partner-depts.dialog.pt-2" | translate }}
  </p>
</mat-dialog-content>
